import configuration from '../config';
import resources from './resources';

export const config = {
    interpolation: {
        escapeValue: false
    },
    lng: configuration.LANG,
    resources
};


export {resources};


